/**
 * Parse a timestamp string from the backend as UTC.
 *
 * The backend uses LocalDateTime which Jackson serialises without a timezone
 * suffix (e.g. "2026-04-20T14:35:42"). JavaScript's Date constructor treats
 * bare ISO strings as *local* time, so browsers in UTC+5 would interpret a
 * freshly-created timestamp as 5 hours in the past. Appending "Z" tells the
 * parser the value is UTC, which matches how the backend stores dates.
 *
 * Date-only strings (no "T") are returned unchanged — they come from LocalDate
 * fields and are typically used for display without a time component.
 *
 * @param {string|null|undefined} str
 * @returns {Date|null}
 */
export function parseUtc(str) {
  if (!str) return null;
  if (typeof str !== "string") return new Date(str);
  // Already carries timezone info — trust it
  if (str.endsWith("Z") || /[+-]\d{2}:\d{2}$/.test(str)) return new Date(str);
  // Datetime string with no zone → treat as UTC
  if (str.includes("T")) return new Date(str + "Z");
  // Date-only string (LocalDate) — pass through unchanged
  return new Date(str);
}
